import * as React from 'react';
import {
	getCatchAreaApi,
	getFishingGearApi,
	getPreservationsApi,
	getSpecies,
	getTerminalsApi,
} from "api/common";
import { Vessel } from "interface/vessel";
import { FC } from "react";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import VesselRenderItem from "ui/dropdownItemList/VesselRenderItem";
import DatePickerComponent from "ui/Date";
import { getVesselFilter } from "api/vessel";
import { DropdownRenderItem } from "ui/dropdownItemList";
import { LandingNoteJournalFilter } from "api/landingNoteoJournal";
import { FishingGear } from "interface/common";

interface CustomProps {
	pageSize: number;
	filterOptions: LandingNoteJournalFilter;
	setFilterOptions: (filterOptions: LandingNoteJournalFilter) => void;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			fishermanLedgerAccount: vessel.res as any,
			vesselName: vessel.nm,
			// vesselRegistrationNumber: vessel.id ? vessel.rn : "",
		});
	};

	const itemRender = (li:any, itemProps:any) => {
		const itemChildren = <span>
			{itemProps.dataItem.displayName}
		</span>;
		return React.cloneElement(li, li.props, itemChildren);
	};

	return (
		<div className="filter-container">
			<div className="filter-items">
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						value={filterOptions.fromDate}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								fromDate: e.target.value as any,
							})
						}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						value={filterOptions.toDate}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								toDate: e.target.value as any,
							})
						}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="res"
						textField="nm"
						label={t("Vessel")}
						value={{
							res: filterOptions.vesselId || null,
						//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						itemRender={VesselRenderItem}
						// label="Velg Fartøy"
						defaultItem={{ res: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(terminal) =>
							setFilterOptions({
								...filterOptions,
								receiverReceivingFacility: terminal.code,
								receiverReceiving: terminal.name,
							})
						}
						data={[]}
						value={{
							code: filterOptions.receiverReceivingFacility || null,
						//	displayName: filterOptions.receiverReceiving || `${t("Choose")}  ${t("Terminal")}`,
							displayName: filterOptions.receiverReceiving || " ",
						}}
						itemRender={DropdownRenderItem}
						dataItemKey="code"
						textField="displayName"
						label={t("Terminal")}
						defaultItem={{ id: null, displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getTerminalsApi}
					/>
				</div>

				<div style={{ width: "200px" }}>
					<CustomDropDownList
						data={[]}
						value={{
							id: filterOptions.fishingGearId || null,
						//	displayName: filterOptions.fishingGear || t("ChooseFishingGear"),
							displayName: filterOptions.fishingGear || " ",
						}}
						className="height-inherit"
						dataItemKey="id"
						label={t("FishingGear")}
						textField="displayName"
						serverFilter={true}
						filterable={true}
						serverFilterApi={getFishingGearApi}
						defaultItem={{ id: null, displayName: t("All") }}
						onSelect={(gear: FishingGear) =>
							setFilterOptions({
								...filterOptions,
								fishingGearCode: gear.code as any,
								fishingGear: gear.name,
								fishingGearId: gear.id as any,
							})
						}
						// popupSettings={{ width: 400 }}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						onSelect={(p) =>
							setFilterOptions({
								...filterOptions,
								catchField1: p.code,
								catchField1Name: p.name,
							})
						}
						label={t("CatchArea")}
						value={{
							code: filterOptions.catchField1 || null,
						//	name: filterOptions.catchField1Name || t("ChooseCatchArea"),
							name: filterOptions.catchField1Name || " ",
						}}
						dataItemKey="code"
						textField="name"
						itemRender={itemRender}
						defaultItem={{ code: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getCatchAreaApi}
						className="height-inherit"
						// popupSettings={{ width: 400 }}
					/>
				</div>
			</div>

			<div className="filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
